import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { getSalesRecordType } from "../../../http/api/MasterAPI";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const SalesRecordTypeSelect = ({ name, ...props }) => {
  const [listSalesRecordType, setListSalesRecordType] = useState([]);
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  useEffect(() => {
    GetSalesRecordType();
  }, []);

  async function GetSalesRecordType() {
    try {
      const response = await getSalesRecordType();
      const varList = response.masterVarInfo;
      const result = varList.map((element) => ({
        salesRecordTypeCd: element.varCd,
        salesRecordTypeName: element.varValue1,
      }));
      setListSalesRecordType(result);
    } catch (error) {
      console.error("Failed to fetch sales record types:", error);
    }
  }

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
    props.moveNext();
  };

  return (
    <FormControl {...props} error={meta.touched && Boolean(meta.error)}>
      <InputLabel id={`${name}-label`} shrink>
        {props.label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        {...field}
        onChange={handleChange}
        label={props.label}
        value={field.value === null ? -1 : field.value}
        inputRef={props.inputRef}
      >
        <MenuItem value={-1}>未選択</MenuItem>
        {listSalesRecordType.map((type) => (
          <MenuItem key={type.salesRecordTypeCd} value={type.salesRecordTypeCd}>
            {type.salesRecordTypeName}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default SalesRecordTypeSelect;
